import { modalEmitter } from 'modules/event-emitters/index';
import { Button } from '@shared/ui/button';
import { ExternalImage } from '@shared/ui/image';
import { Breadcrumbs } from '@shared/ui/breadcrumbs';
import { PageContainer } from '@shared/ui/content-containers';
import { PageTitle } from '@shared/ui/titles';
import { ISeoPage, PageBanner, PageHelmet } from '@widgets/seoPage';
import { useRouteLoaderData, useLoaderData } from '@shared/lib/routing';
import { useTranslation } from 'react-i18next';
import VacanciesModal from 'frontend/Components/Vacancies/VacanciesModal/VacanciesModal';
import { Preloader } from '@shared/ui/preloader';
import ErrorPage from 'frontend/Pages/ErrorPage/ErrorPage';
import { HtmlParser } from '@shared/html';
import type { IDetailedVacancyInfo } from '../model/types';

export function Vacancy() {
  const { t } = useTranslation();
  const {
    country: { main_domain: mainDomain },
    city,
  } = useRouteLoaderData('city-layout');
  const { pageData, loading } = useLoaderData<{
    seoPageData: ISeoPage;
    vacancyData: { item: IDetailedVacancyInfo };
  }>();

  if (loading) {
    return <Preloader />;
  }

  const { seoPageData, vacancyData } = pageData;

  const vacancy = vacancyData.item;

  if (!vacancy || Array.isArray(vacancy)) {
    return (
      <ErrorPage
        action_link="/vakansii"
        action_text={t('Vacancies.vacancyGetAll')}
      />
    );
  }

  const { title = '', image, description } = vacancy || {};

  return (
    <>
      <PageBanner bannerData={seoPageData.banner} mainDomain={mainDomain} />
      <PageContainer>
        <PageHelmet
          cityName={city.city_name}
          seo={seoPageData.seo}
          title={title}
          ogTitle={title}
          image={image}
          mainDomain={mainDomain}
        />
        <Breadcrumbs
          links={[
            {
              href: '/vakansii',
              text: t('Vacancy.vacanciesTitle'),
            },
            {
              text: title,
            },
          ]}
        />
        <PageTitle>{title}</PageTitle>
        <div className="flex flex-col items-start gap-4 lg:flex-row [&>*:last-child]:w-full">
          <ExternalImage
            mainDomain={mainDomain}
            src={image}
            alt={title}
            width={450}
            height={300}
          />
          <HtmlParser
            data={description?.replace('<>', '')}
            imgProps={{ mainDomain }}
          />
        </div>
        <Button
          className="inline-block! self-center lg:hidden!"
          onClick={() => {
            modalEmitter.emit('Vacancies-mobile.Modal.Open', vacancy?.id);
          }}
        >
          {t('localization.sendResume')}
        </Button>
        <Button
          className="hidden! lg:inline-block! lg:self-center"
          onClick={() => {
            modalEmitter.emit('Vacancies.Modal.Open', vacancy?.id);
          }}
        >
          {t('localization.sendResume')}
        </Button>
        <VacanciesModal />
      </PageContainer>
    </>
  );
}

export default Vacancy;
